import React, { useMemo } from 'react'
import {
    DirectMessageIcon,
    DirectMessageName,
} from '@components/DirectMessages/DirectMessageListItem'
import { FavoriteChannelButton } from '@components/FavoriteChannelButton/FavoriteChannelButton'
import { ActionNavItem } from '@components/NavItem/ActionNavItem'
import { Badge, Box, Stack } from '@ui'
import { useMyAbstractAccountAddress } from 'hooks/useAbstractAccountAddress'
import { useCreateLink } from 'hooks/useCreateLink'
import {
    DmAndGdmModel,
    DMChannelContextUserLookupProvider,
    useDMLatestMessage,
    useMyUserId,
} from 'use-towns-client'

export const CondensedChannelNavItem = React.memo(function CondensedChannelNavItem(props: {
    channel: DmAndGdmModel
    unread: boolean
    favorite: boolean
    isUnreadSection?: boolean
}) {
    const { channel, unread, favorite, isUnreadSection = false } = props
    const { data: abstractAccountAddress } = useMyAbstractAccountAddress()
    const { createLink } = useCreateLink()
    const link = useMemo(() => createLink({ messageId: channel.id }), [createLink, channel.id])

    const { unreadCount } = useDMLatestMessage(channel.id)
    const myUserId = useMyUserId()
    return (
        <DMChannelContextUserLookupProvider
            key={channel.id}
            channelId={channel.id}
            abstractAccountAddress={abstractAccountAddress}
        >
            <ActionNavItem
                badge={
                    <Stack horizontal gap="sm">
                        <FavoriteChannelButton
                            channelId={channel.id}
                            favorite={favorite}
                            isUnreadSection={isUnreadSection}
                        />
                        {unread && <Badge value={unreadCount} />}
                    </Stack>
                }
                key={channel.id}
                icon={
                    <Box width="x4" shrink={false}>
                        <DirectMessageIcon channel={channel} width="x4" myUserId={myUserId} />
                    </Box>
                }
                id={channel.id}
                label={
                    <DirectMessageName channelId={channel.id} label={channel.properties?.name} />
                }
                highlight={unread}
                link={link}
                minHeight="x5"
            />
        </DMChannelContextUserLookupProvider>
    )
})
